<template>
  <section :id="`comp_id_${compProps.elementId}`" class="tab-item__section" ref="tabDom">
    <nav
      ref="navDom"
      :class="`swiper-container tab-nav-${privateProps.level} ${privateProps.tabType === '1' ? 'timeTab' : ''}`"
      :style="`background-color: ${privateProps.level === '0' && !isQ20220709101555 ? privateProps.backgroundColor: privateProps.tabBackGroundColor}`"
    >
      <!--一级tab-->
      <div v-if="privateProps.level==0"
        :class="`swiper-wrapper tab-item-0 time-tab-swiper ${isQ20220709101555 ? 'tab-Q20220709101555' : ''}`">
        <div
          :class="`swiper-slide tab-sub-item-0 time-tab-item`"
          data-actionid="4"
          :data-itemtext="tab.name"
          @click="tabChange(index)"
          v-for="(tab, index) in children"
          :key="index"
          :style="{
            'width': isQ20220709101555 ? '25%' : (children.length <= 2 ? '50%':'auto')
          }">
          <div
            v-if="privateProps.tabType === `1`"
            :style="getStyles(index)"
            class="time-tab-item-content"
          >
            {{getTimeTxt(tab)}}
          </div>
          <div v-else :style="getStyles(index)">{{tab.name}}</div>
          <div v-if="privateProps.tabType !== '1' " class="iconfont icon-arrow-wide" :style="`color: ${currentTab === index ? privateProps.activeColor : privateProps.backgroundColor};`"></div>
        </div>
      </div>
      <!--二级tab-->
      <template v-if="privateProps.level==1">
        <div :class="`swiper-wrapper tab-item-1 time-tab-swiper`">
          <div
            :class="`swiper-slide tab-sub-item-1 time-tab-item`"
            data-actionid="4"
            :data-itemtext="tab.name"
            @click="tabChange(index)"
            v-for="(tab, index) in children"
            :key="index"
            :style="tabBgColor(index)">
            <div
              v-if="privateProps.tabType === `1`"
              class="time-tab-item-content"
              :style="getStyles(index)"
            >
            {{getTimeTxt(tab)}}
            </div>
            <div v-else :style="getStyles(index)" >{{tab.name}}</div>
          </div>
        </div>
        <div v-if="needShowAll&&!showAll"
          class="tab_more"
          data-actionid="4"
          data-value="-1"
          @click="tabChange(-1)"
          :style="{'background-image': `linear-gradient(90deg, ${privateProps.tabBackGroundColor}00 13%, ${privateProps.tabBackGroundColor} 50%)`}"
        >
          <div class="iconfont icon-solid-arrow" :style="{'color': privateProps.activeColor}"></div>
        </div>
      </template>
    </nav>
    <div v-if="privateProps.level==1&&needShowAll&&showAll" class="tab_all_layer" :style="{'background-color': privateProps.tabBackGroundColor}">
      <div class="tab-sub-item-1"
        @click="tabChange(index)"
        v-for="(tab, index) in children"
        :key="'layer'+index"
        :style="tabBgColor(index)">
        <div
          v-if="privateProps.tabType === `1`"
          :style="getStyles(index)"
          class="time-tab-item-content">
          {{getTimeTxt(tab)}}
        </div>
        <div v-else :style="getStyles(index)">{{tab.name}}</div>
      </div>
      <div
        @click="tabChange(-1)"
        class="tab-sub-item-1"
        :style="getStyles(children.length)+tabBgColor(children.length)">
        收起
        <div class="iconfont icon-solid-arrow up" :style="{'color': privateProps.activeColor}"></div>
      </div>
    </div>
    <component :is="comp.compName"
      :tabIndex="`${currIndex}`"
      :compIndex="`${childIndex}`"
      v-for="(comp, currIndex) in tabChildren"
      :key="$root.promotionId+comp.elementId"
      :compProps="comp"
      :style="`background-color: ${comp.mate && comp.mate.privateProps ? comp.mate.privateProps.backgroundColor : ''}`"></component>
  </section>
</template>
<script>
/**
 * 注册tab内可以使用的组件，但是其实没啥必要，可以全局注册组件。为以后动态注册组件提供基础，并且提供组件发布平台。这是后话了。
 */
import { mapState } from 'vuex'
import ElementImageComp from './ElementImageComp'
import ElementRedPacketComp from './ElementRedPacketComp'
import ElementHousesComp from './ElementHousesComp'
import ElementDocComp from './ElementDocComp'
import ElementCountDownComp from './ElementCountDownComp'
import ElementLandlordStoryComp from './ElementLandlordStoryComp'
import { eventBus } from '@/utils'
import { eventBusV } from '@/utils/q_hook'

export default {
  name: 'ElementTabComp',
  components: {
    ElementImageComp,
    ElementRedPacketComp,
    ElementHousesComp,
    ElementDocComp,
    ElementCountDownComp,
    ElementLandlordStoryComp
  },
  data() {
    const currentTab = Math.min(this.$route.query.activetab || 0, this.compProps.mate.items.length - 1)
    return {
      currentTab,
      showAll: false,
      needShowAll: false,
      childIndex: '',
      // 开始时间戳
      dateBegin: 0,
      serviceTime: this.$root.serviceTime || Date.now()
    }
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    },
    tabIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    ...mapState(['houseFilter']),
    children() { // 计算属性可以很好的避免内部观察者多次不必要的计算
      let items = [].concat(this.compProps.mate.items || [])
      // if (this.$root.isMobile && this.compProps.mate.privateProps.level === '1' && items.length > 8 && !this.showAll) {
      //   items = items.slice(0, 7)
      // }
      return items
    },
    privateProps() {
      if (this.compProps.mate) {
        return this.compProps.mate.privateProps
      } else {
        return []
      }
    },
    tabChildren() {
      if (this.children[this.currentTab]) {
        return this.children[this.currentTab].items
      } else {
        return []
      }
    },
    isQ20220709101555() {
      return ['Q20220709101555'].indexOf(this.$route.query.id) > -1
    }
  },
  watch: {
    'houseFilter.promotionId'(newVal) {
      setTimeout(() => {
        this.swiper && this.swiper.update()
      }, 1000)
    }
  },
  created() {
    let items = []
    if (this.compProps.mate) {
      items = this.compProps.mate.items
    }
    if (items.length > 5 && this.$root.isMobile) {
      this.needShowAll = true
    }
    // 页面第一次加载的时候更新第一个tab的index
    this.getChildIndex()
  },
  mounted() {
    if (this.privateProps.level === '0') {
      // eslint-disable-next-line
      this.swiper = new Swiper(`#comp_id_${this.compProps.elementId} .tab-nav-0`, {
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: this.currentTab
      })
    }
    if (this.privateProps.level === '1') {
      // eslint-disable-next-line
      this.swiper = new Swiper(`#comp_id_${this.compProps.elementId} .tab-nav-1`, {
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: this.currentTab
      })
    }
    this.getActiveTabIndex()
    // 接受最新的服务器时间
    eventBus.$on('timeCdEnd', (serviceTime) => {
      this.serviceTime = serviceTime
    })
    // TOC-4160 默认选中专属房屋所在城市tab
    if (process.env.VUE_APP_LOCAL === 'Q') {
      eventBusV.$on('exclusiveHouse', (houseDetail = {}) => {
        const activeIndex = this.children.findIndex((item) => item.name === houseDetail?.cityName)
        if (activeIndex > -1) {
          this.tabChange(activeIndex)
        }
      })
    } else {
      eventBus.$on('exclusiveHouse', (houseDetail = {}) => {
        const activeIndex = this.children.findIndex((item) => item.name === houseDetail?.cityName)
        if (activeIndex > -1) {
          this.tabChange(activeIndex)
        }
      })
    }
  },
  methods: {
    /**
     * Tab切换事件回调
     * @param {int} index 点击的tab对象索引
     */
    tabChange(index) { // -1表示用户点击的是更多按钮
      const tabDom = document.getElementById(`comp_id_${this.compProps.elementId}`)
      if (index === -1) {
        this.showAll = !this.showAll
      } else {
        if (this.showAll) {
          this.showAll = false
        }
        if (this.privateProps.tabType !== '1') {
          tabDom.style.height = tabDom.offsetHeight + 'px'
        }
        this.currentTab = index
        this.swiper.slideTo(index)
      }
      this.dateBegin = new Date().getTime()
      this.pollHouseDomHeight()
      index > -1 && window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_TRAVELAROUND_TAB_CLICK',
        ext: {
          tab_id: this.children[index] && this.children[index].__id__,
          tab_text: this.children[index] && this.children[index].name,
          position: index,
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle
        }
      })
    },
    pollHouseDomHeight() {
      const houseDom = document.getElementById(`comp_id_${this.tabChildren[0].elementId}`)
      const timerId = setTimeout(() => {
        // 150-->图片能够渲染出来时的最小高度
        if (houseDom && houseDom.offsetHeight > 150) {
          clearTimeout(timerId)
          this.dateBegin = 0
          this.$refs.tabDom.style.height = 'auto'
        } else {
          // console.log(new Date().getTime() - this.dateBegin, 'time')
          if (new Date().getTime() - this.dateBegin > 5000) {
            clearTimeout(timerId)
            this.dateBegin = 0
          } else {
            this.pollHouseDomHeight()
          }
        }
      }, 200)
    },
    /**
     * Tab每个对象计算它的样式
     * @param {int} index tab对象索引
     */
    getStyles(index) { // 不同的按钮状态 其实是通过数据中的leve来区分的该使用哪个class，不过vue的scoped因为使用选择器，所以会影响性能。但是活动页一般都是量大，不会过于复杂。
      let color = `color: ${this.currentTab === index ? this.privateProps.activeTextColor : this.privateProps.textColor}`
      let bgColor = ''
      let fontSize = ''
      let fontWeight = ''
      if (this.privateProps.tabType === '1' || this.isQ20220709101555) {
        bgColor = `background-color: ${this.currentTab === index ? this.privateProps.activeColor : this.privateProps.backgroundColor}`
      }
      if (this.privateProps.level === '0' && !this.isQ20220709101555) {
        fontSize = `font-size: ${this.currentTab === index ? '17px' : '14px'}`
      }
      if (this.privateProps.level === '0' && !this.isQ20220709101555) {
        fontWeight = `font-weight: ${this.currentTab === index ? 'bold' : 600}`
      } else if (this.privateProps.level === '1' && !this.isQ20220709101555) {
        fontWeight = `font-weight: ${this.currentTab === index ? 'bold' : 'normal'}`
      }
      return color + ';' + bgColor + ';' + (this.privateProps.tabType === '1' ? '' : fontWeight) + ';' + fontSize + ';'
    },
    tabBgColor(index) {
      const isActive = this.currentTab === index
      const { activeColor, borderColor, backgroundColor } = this.privateProps
      const borderColorShow = borderColor || backgroundColor ? `${borderColor || backgroundColor}66` : ''
      return `background-color:${isActive ? activeColor : 'transparent'};border-color:${isActive ? activeColor : borderColorShow};`
    },
    getChildIndex() { // Q埋点计算 暂时先这么处理 后期统一吧
      // const tabLevel = this.compProps.mate.privateProps.level
      this.childIndex = `${this.compIndex}_${this.currentTab}`
    },
    getTimeTxt(tab = {}) {
      const { startTime, activityEndTime, endTime } = tab
      // 服务器当前时间
      const datenow = this.serviceTime
      let moment = require('moment')
      let tabText = moment(startTime).format('HH:mm')

      if (tabText === 'Invalid date' || !endTime) {
        return tab.name
      }
      // 活动已结束
      if (datenow > activityEndTime) {
        return '活动已结束'
      }
      if (this.diffInDay(datenow, startTime)) {
        tabText += '未开始'
      } else if (this.diffInDay(datenow, endTime)) {
        tabText += '进行中'
      } else {
        tabText += '已结束'
      }
      return tabText
    },
    getActiveTabIndex() {
      if (this.privateProps && this.privateProps.tabType === '1') {
        const len = this.children.length
        for (let i = 0; i < len; i++) {
          const item = this.children[i]
          const dateNow = this.serviceTime
          if (this.diffInDay(item.startTime, dateNow) && this.diffInDay(dateNow, item.endTime)) {
            // 如果当前第一位状态 就返回
            if (i === 0) {
              return
            } else {
              this.tabChange(i)
              return
            }
          }
        }
      }
    },
    diffInDay(startTime, endTime) {
      if (typeof startTime !== 'number' || typeof endTime !== 'number') {
        return false
      }
      const from = new Date(startTime)
      const to = new Date(endTime)
      const fromH = from.getHours()
      const toH = to.getHours()
      if (fromH < toH) {
        return true
      } else if (fromH === toH) {
        return from.getMinutes() < to.getMinutes()
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@function size($n) {
  @return $n/375 * 100vw;
}
.tab-item__section {
  position: relative;
}
.tab-item__section * {
  box-sizing: border-box;
}

.tab-sub-item-0 {
  position: relative;
  white-space: nowrap;
  font-size: 14px;
  height: size(44);
  cursor: pointer;
  width: auto;
  line-height: size(44);
  padding: 0 size(15);
  text-align: center;
}
.icon-arrow-wide {
  position: absolute;
  z-index: 1;
  bottom: -19px;
  left: 50%;
  font-size: 12px;
  margin-left: -22px;
}

.timeTab {
  display: flex;
  height: 45px;
  align-items: center;
  .time-tab-swiper {
    padding-left: 0;
    .time-tab-item {
      flex: 1;
      height: 100%;
      padding: 0;
      height: auto;
      .time-tab-item-content {
        height: 46px;
        line-height: 45px;
        margin: 0;
        border-radius: 0;
        padding: 0 20px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
}

.tab-item-1 {
  display: flex;
  box-sizing: border-box;
  padding: size(10) size(15) 0;
}

.tab-sub-item-1 {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  text-align: center;
  width: size(63);
  height: auto;
  min-height: size(28);
  // max-height: size(34);
  border: 1px solid rgba(255,255,255,0.6);
  border-radius: 4px;
  margin-right: size(7);
  padding: size(4) size(6);
  overflow: hidden;
  &:last-child{
    margin-right: size(60)
  }
}

.tab-sub-item-1 > div {
  font-size: 12px;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  text-align: center;
}
.tab_more {
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  height: 50px;
  width: size(50);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: size(5);
}
.icon-solid-arrow {
  font-size: 12px;
}
.icon-solid-arrow.up {
  transform: rotate(180deg);
}
.tab_all_layer {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-flow: wrap;
  padding: size(10) size(11.5) size(2);
  box-shadow: 0 24px 20px 2px rgba(0,0,0,0.16);
  background: #1DA5E2;
  .tab-sub-item-1 {
    height: auto;
    min-height: size(28);
    // max-height: size(34);
    margin: 0 size(3.5) size(8);
    &>div {
      white-space: normal;
      justify-content: center;
      font-size: 12px;
      line-height: 14px;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
.tab-Q20220709101555 {
  padding: size(8) size(12) 0;
  .tab-sub-item-0 {
    padding: 0 size(3);
    &>div {
      border-radius: size(20);
      height: size(40);
      line-height: size(40);
      font-size: size(14);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &:last-child {
      margin-right: size(24);
    }
  }
  .iconfont {
    display: none;
  }
}
</style>
